import { Component, EventEmitter, HostBinding, OnInit, Output } from '@angular/core';
import { ServiceService } from '../service/service.service';

@Component({
	selector: 'common-label-selector',
	templateUrl: './label-selector.component.html',
	styleUrls: ['./label-selector.component.scss']
})
export class LabelSelectorComponent implements OnInit {
	chipListShow = true;
	@Output() open = new EventEmitter();
	@HostBinding('class.label-selector') hostClass = true;
	constructor(public svr: ServiceService) {}

	ngOnInit() {}
	deleteLabel(index: number) {
		this.svr.data.selectedLabels.splice(index, 1);
		this.svr.refreshData().subscribe();
	}
}
